<template>
  <div v-if="isShow" id="company-ochart" :style="`zIndex:${zIndex};height:${height}`">
    <!-- <div class="componentclose" @click="close">X</div> -->
    <div
      :class="{ 'company-ochart-left': true, 'show-menu': showSearch, 'hide-menu': !showSearch }"
      :style="`height:100%; left: 0;transition: none;`"
    >
      <div class="control-btn" @click="changeMenuStatus">操作选项</div>
      <div class="structure-left flex-column">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="O-chart" name="O-chart"> </el-tab-pane>
          <el-tab-pane label="搜索" name="搜索"></el-tab-pane>
          <el-tab-pane label="公司架构" name="公司架构">
            <div class="text-center ">
              <!-- 整体操作： -->
              <el-popover placement="right" width="700" trigger="click">
                <div class="radish-btn radish-btn-primary radish-btn-small" @click="uploadAtta">上传ochart附件</div>
                <FileTable
                  :files="companyFiles"
                  :paginate="false"
                  width="600"
                  :show-download="isAdmin"
                  height="300"
                  :on-delete="deleteCompanyAtta"
                />
                <span slot="reference" class="radish-btn radish-btn-primary uploadAtta" style="margin-left: 10px;"
                  >ochart附件</span
                >
              </el-popover>
              <div class="radish-btn radish-btn-primary" style="margin-left: 10px;" @click="loadData">刷新数据</div>
              <div
                class="radish-btn radish-btn-primary"
                style="margin-left: 10px;"
                @click="showDepartmentMember = !showDepartmentMember"
              >
                {{ showDepartmentMember ? '隐藏' : '显示' }}部门重要人员
              </div>
              <div class="radish-btn radish-btn-primary" style="margin-left: 10px;" @click="insertKPI">提交kpi</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="操作" name="操作"></el-tab-pane>
        </el-tabs>
        <div class="flex-column flex-left-space overflow-auto">
          <div class="flex-column overflow-auto structure-manager-left">
            <div class="radish-act-grp">
              <span>高管：</span>
              <div class="radish-btn radish-btn-primary" @click="searchCompanyManager">全公司搜索</div>
            </div>
            <el-input
              v-model="managerFilterText"
              placeholder="输入关键字按回车进行搜索"
              size="mini"
              @keyup.enter.native="toFilterManagerText(managerFilterText)"
            ></el-input>
            <el-tree
              ref="managerTree"
              class="flex-left-space overflow-auto"
              :data="managerTree"
              :props="defaultProps"
              node-key="_id"
              show-checkbox
              :expand-on-click-node="false"
              :filter-node-method="managerFilterNode"
            >
              <span slot-scope="{ node, data }">
                <span
                  onselectstart="return false;"
                  :style="`margin-right:5px;color:${data.hasSetStructure ? '#E6A23C' : '#409eff'};`"
                  @mouseup="event => drop(event, data, node)"
                  @mousedown="event => drag(event, data, '高管')"
                  @dblclick="showRadishDetail(data)"
                >
                  {{ data.姓名 }}（{{ data.目前职位 }}）（{{ data.专业职级 }}）
                </span>
              </span>
            </el-tree>
          </div>
          <div class="flex-column overflow-auto flex-left-space">
            <div class="radish-act-grp">
              部门操作：
              <div class="radish-btn radish-btn-primary" @click="showDialog">合并</div>
              <div class="radish-btn radish-btn-primary" @click="chooseShowDepartment">全选已显示</div>
              <div class="radish-btn radish-btn-primary" @click="clearCheckedDepartment">清空已勾选</div>
            </div>
            <el-input
              v-model="filterText"
              placeholder="输入关键字按回车进行搜索"
              size="mini"
              @keyup.enter.native="toFilterText(filterText)"
            ></el-input>
            <el-tree
              ref="tree"
              class="flex-left-space overflow-auto"
              :data="tree"
              :props="defaultProps"
              node-key="_id"
              show-checkbox
              :expand-on-click-node="false"
              :default-expanded-keys="defaultExpandedKeys"
              :filter-node-method="filterNode"
            >
              <span slot-scope="{ node, data }">
                <span
                  onselectstart="return false;"
                  :style="`margin-right:5px;color:${data.hasSetStructure ? '#E6A23C' : '#409eff'};`"
                  @mouseup="event => drop(event, data, node)"
                  @mousedown="event => drag(event, data, '部门')"
                  @dblclick="showMemberList(data)"
                >
                  {{ data.名称 }}（{{ data.人数 }}）
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </div>
    <div
      v-loading="isLoading"
      :class="{ 'company-ochart-right': true, 'show-menu': showSearch }"
      @click="resetPosition"
    >
      <OrgChart
        :data="chartData"
        :vue="Vue"
        :html-to-canvas="html2canvas"
        node-id="_id"
        container-class="orgchart-container"
        chart-class="departmentOchart-chart"
        common-class="fa"
        spinner-class="fa fa-circle-o-notch fa-spin spinner"
        export-btn-class
        left-arrow-class="fa-chevron-left"
        right-arrow-class="fa-chevron-right"
        up-arrow-class="fa-chevron-up"
        down-arrow-class="fa-chevron-down"
        toggle-btn-on-class="fa-plus-square"
        toggle-btn-off-class="fa-minus-square"
        parent-node-symbol-class
        :zoom="false"
        @drag="updateDataOnDrag"
      >
        <div slot-scope="{ nodeData }">
          <div
            v-if="nodeData.类型 === 'members'"
            id="memberbox"
            :class="[nodeData.members && nodeData.members.length > 30 ? 'widebox' : 'narrowbox', 'title']"
          >
            <span
              v-for="item in nodeData.members"
              :key="item._id"
              style="position:relative;"
              :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag mr5 md5']"
              @dblclick="_showRadishDetail(item)"
            >
              {{ item.姓名 }} <span v-if="item.专业职级">（{{ item.专业职级 }}）</span>
              <span v-if="!item.手机 && !showDepartmentMember" style="line-height: 14px;" class="cc-icon">c</span>
              <i class="el-icon-star-on" @click="_showscore(item)"></i>
            </span>
          </div>
          <div v-else-if="nodeData.类型 === 'branch'" id="branchbox">
            <span class="branch-label">分支机构：</span>
            <div class="branch-position-box">
              <div
                v-for="(item, index) in nodeData.members"
                :key="item._id"
                class="branch-node"
                @dblclick="openCompany(item)"
              >
                <span class="branch-node-content">{{ item.公司名称 }}</span>
                <div v-if="index !== nodeData.members.length - 1" class="div-ochart-line"></div>
              </div>
            </div>
          </div>
          <div v-else-if="nodeData.isManager" id="org-manager" class="title ">
            <span class="alpha-tag mr5 md5 " @dblclick="_showRadishDetail(nodeData)">
              {{ nodeData.名称 }} <span v-if="nodeData.专业职级">（{{ nodeData.专业职级 }}）</span>
              <span v-if="!nodeData.手机 && !showDepartmentMember" style="line-height: 14px;" class="cc-icon">c</span>
              <i class="el-icon-star-on" @click="_showscore(nodeData)"></i>
              <el-dropdown class="orgdropdown">
                <span class="el-dropdown-link"> <i class="el-icon-setting" style="color:#6a7dc5;"></i> </span>
                <el-dropdown-menu ref="dropdown" slot="dropdown">
                  <el-dropdown-item @click.native="deleteDepartment(nodeData)">结构图中移除该部门</el-dropdown-item>
                  <el-dropdown-item @click.native="insertDepartment(nodeData)">新建部门</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </div>

          <div
            v-else
            id="orgdepartment"
            :class="[nodeData.isManager ? 'manager' : '', 'title company-orgdepartment-across']"
            style="overflow:unset"
            @dblclick="showDepartmentOchart(nodeData)"
          >
            <el-badge :is-dot="!!nodeData.isManager" class="item span-maxcontent mt3">{{ nodeData.名称 }}</el-badge>
            <p v-if="nodeData.isManager" class="span-maxcontent ochart-character">{{ nodeData.专业职级 }}</p>
            <p v-else-if="nodeData.A角" class="span-maxcontent ochart-character" @click="setMemberCharacter(nodeData)">
              {{ nodeData.A角 }}
            </p>
            <p class="span-maxcontent">
              <span>{{ nodeData.人数 }}</span>
              <el-dropdown v-if="nodeData.pid === nodeData.公司" class="orgdropdown">
                <span class="el-dropdown-link"> <i class="el-icon-setting" style="color:#fff"></i> </span>
                <el-dropdown-menu ref="dropdown" slot="dropdown">
                  <el-dropdown-item @click.native="insertDepartment(nodeData)">新建部门</el-dropdown-item>
                  <el-dropdown-item @click.native="showMemberList(nodeData)">显示部门人员列表</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-else-if="!nodeData.isManager" class="orgdropdown">
                <span class="el-dropdown-link"> <i class="el-icon-setting" style="color:#fff"></i> </span>
                <el-dropdown-menu ref="dropdown" slot="dropdown">
                  <el-dropdown-item @click.native="deleteDepartment(nodeData)">结构图中移除该部门</el-dropdown-item>
                  <el-dropdown-item @click.native="updateDepartmentName(nodeData)">修改部门名称</el-dropdown-item>
                  <el-dropdown-item @click.native="insertDepartment(nodeData)">新建部门</el-dropdown-item>
                  <el-dropdown-item @click.native="showMemberList(nodeData)">显示部门人员列表</el-dropdown-item>
                  <el-dropdown-item @click.native="setMemberCharacter(nodeData)">设置AB角</el-dropdown-item>
                  <el-dropdown-item @click.native="mergeDepartment(nodeData)">部门查重合并</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-else class="orgdropdown">
                <span class="el-dropdown-link"> <i class="el-icon-setting" style="color:#6a7dc5;"></i> </span>
                <el-dropdown-menu ref="dropdown" slot="dropdown">
                  <el-dropdown-item @click.native="deleteDepartment(nodeData)">结构图中移除该部门</el-dropdown-item>
                  <el-dropdown-item @click.native="insertDepartment(nodeData)">新建部门</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
          </div>
        </div>
      </OrgChart>
    </div>
    <!-- 操作弹窗 -->
    <OchartDialog ref="OchartDialog" btn-text="部门" @cancel="cancelDialog" @confirm="confirmDialog"></OchartDialog>
    <!-- 设置部门角色弹窗 -->
    <OchartCharacter ref="OchartCharacter" @refreshTable="loadData"></OchartCharacter>
    <!-- 合并部门弹窗 -->
    <el-dialog title="选择主要数据" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" width="300">
      <el-radio-group v-model="radio">
        <el-radio v-for="item in checkedDepartments" :key="item._id" :label="item._id"> {{ item.名称 }} </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmMerge">确 定</div>
      </span>
    </el-dialog>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      choose-btn-text="选择"
      :default-company="companyName"
      @choose="chooseManager"
    >
    </serch-radish-dialog>
    <!-- 附件 -->
    <UploadDialog
      ref="UploadDialog"
      type="附件"
      label="公司O-Chart"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    />
  </div>
</template>
<script>
import OrgChart from '@c42/vue-orgchart'
import Vue from 'vue'
import html2canvas from 'html2canvas'
import OchartDialog from '../ochartDialog/OchartDialog'
import OchartCharacter from '../ochartDialog/OchartCharacter'
import serchRadishDialog from '../component/serchRadishDialog.vue'
import { FileTable } from '../../../file'
import { 专业职级排序 } from '../../statistics/variant/fixedvariant'

// 人选展示的最小职级
const showLevelMin = 'VP'

export default {
  components: { OrgChart, OchartDialog, OchartCharacter, serchRadishDialog, FileTable },
  props: {
    company: { type: Object, default: () => ({}) },
    height: { type: String, default: '100%' },
    showSearch: { type: Boolean, default: false },
  },
  data() {
    return {
      Vue,
      html2canvas,
      companyName: '',
      isShow: false,
      zIndex: '',
      // showSearch: false,
      isLoading: false,
      filterText: '',
      chartData: {
        _id: 1,
        名称: '无',
        children: [],
      },
      tree: [],
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'children',
        label: '名称',
      },
      ochartDataItems: [],
      ochartDragingItem: {
        childItem: {},
        oldParentItem: {},
        newParentItem: {},
      },
      targetRadishDom: null,
      isDraging: false,
      dialogVisible: false,
      radio: '',
      checkedDepartments: [],
      mergeMainDepartmentId: null,
      managerFilterText: '',
      managerNode: [],
      managerTree: [],
      inStructure: { department: [], manager: [] },
      companyFiles: [],
      isAdmin: false,
      companyId: '',
      activeTabName: '公司架构',
      showDepartmentMember: false,
      branchCompany: [],
    }
  },
  watch: {
    tree(newValue, oldValue) {
      if (newValue.length !== 0) {
        newValue[0].disabled = true
        this.defaultExpandedKeys = [newValue[0]._id]
      }
    },
    activeTabName(newValue, oldValue) {
      if (newValue !== '公司架构') {
        this.$emit('updateTabName', newValue)
        this.close()
      }
    },
    showDepartmentMember(newValue, oldValue) {
      this.toTreeData(this.managerNode.concat(this.ochartDataItems))
    },
  },
  methods: {
    async getBrachCompany() {
      const { branch } = this.company
      if (!Array.isArray(branch) || branch.length === 0) return (this.branchCompany = [])
      const res = await app.service('company').getBranch(branch)
      if (res.status !== 'success') return this.$message.error(res.msg)
      this.branchCompany = res.data
    },
    changeMenuStatus() {
      this.$emit('changeMenuStatus')
    },
    async uploadAtta() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
      const dom = this.$el.querySelector('.uploadAtta')
      if (dom) dom.click()
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.UploadDialog.visible()
      const res = response[0]
      try {
        const option = {
          createdAt: res.createdAt,
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
          type: '公司O-Chart',
          companyId: this.companyId,
        }
        await app.service('company').insertCompanyAtta(option)
        this.getCompanyFiles()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async uploadError(res) {
      console.log(res)
    },
    async getCompanyFiles() {
      const result = await app.service('company').getCompanyAtta(this.companyId)
      if (result.status === 'success')
        this.companyFiles = result.data
          .filter(v => v.type === '公司O-Chart')
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
      else this.$message.error(result.msg)
    },
    // 附件删除
    async deleteCompanyAtta(value) {
      this.$confirm('此操作将删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const result = await app.service('company').deleteAtta(value._id)
          if (result.status === 200) {
            let index
            this.companyFiles.forEach((item, ind) => {
              if (item._id === value._id) index = ind
            })
            this.companyFiles.splice(index, 1)
            this.$message.success('删除成功!')
          } else this.$message.error(result.msg)
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },

    toFilterManagerText(filterText) {
      this.$refs.managerTree.filter(filterText)
    },
    async searchCompanyRadish(managerFilterText) {
      const res = await app.service('misc').searchEs({
        keywords: `${managerFilterText} ${this.companyName}`,
        type: '人选',
        fields: ['姓名', '公司', '部门', '职能模块', '手机'],
        and: true,
      })
      if (res.status === 'success') {
        this.companyManager = res.data
        this.toManagerTreeData()
      }
    },
    showRadishDetail(radish) {
      window.open(`${window.frontend}/#/radish-detail-blank/${radish.rid || radish._id}`, '_blank')
    },
    searchCompanyManager() {
      this.$refs.serchRadishDialog.open()
    },
    async chooseManager(radish) {
      radish.职级 = '1'
      const res = await app.service('radish').modifyById({ _id: radish._id, data: { 职级: '1' } })
      if (res.status == 'success') {
        this.getCompanyManager()
      } else this.$message.error(`${res.msg}`)
    },
    async confirmMerge() {
      const first = this.radio
      if (!first) this.$message('请选择一个部门作为主要部门')
      const second = this.checkedDepartments.filter(v => v._id !== first).map(v => v._id)
      const res = await app.service('company').mergeDepartment({ first, second })
      if (res.status === 'success') this.loadData()
      else this.$message.error(res.msg)
      this.dialogVisible = false
    },
    showDialog() {
      this.dialogVisible = true
      this.checkedDepartments = this.$refs.tree.getCheckedNodes().filter(v => v.pid !== v.公司)
    },
    chooseShowDepartment() {
      const { filterText, departmentNodes } = this
      const hasCheckedDepartments = this.$refs.tree.getCheckedNodes()
      const checkedDepartments = departmentNodes.filter(
        v => !v.disabled && v.pid !== v.公司 && v.名称.includes(filterText),
      )
      checkedDepartments.forEach(v => {
        const flag = hasCheckedDepartments.find(val => val._id == v._id)
        if (!flag) hasCheckedDepartments.push(v)
      })
      this.$refs.tree.setCheckedNodes(hasCheckedDepartments)
    },
    clearCheckedDepartment() {
      this.checkedDepartments = []
      this.$refs.tree.setCheckedKeys([])
    },
    showDepartmentOchart(nodeData) {
      if (nodeData.名称 === nodeData.公司) return this.$message.warning('公司节点无法打开部门ochart')

      if (nodeData.isManager) this.showRadishDetail(nodeData)
      else {
        app.root.$refs.departmentOchart.open({
          department: nodeData.部门,
          companyName: nodeData.公司,
        })
      }
    },
    async deleteDepartment(nodeData) {
      if (nodeData.pid === nodeData.公司) return this.$message.error('公司无法删除')
      const res = await app.service('company').deleteCompanyStructure(nodeData._id)
      if (res.status == 'success') this.loadData()
      else this.$message.error(res.msg)
    },
    updateDepartmentName(nodeData) {
      this.updateNameDepa = nodeData
      this.openDialog('改名')
    },
    async confirmUpdateDepa(result) {
      const res = await app.service('company').updateDepartmentName({
        _id: this.updateNameDepa._id,
        newName: result,
      })
      if (res.status === 'success') this.loadData()
    },
    insertDepartment(nodeData) {
      this.openDialog('添加部门')
      this.parentDepartment = nodeData
    },
    async confirmCreateDepa(result) {
      if (!result) return this.$message.warning('请输入内容')

      const newDepartment = {
        名称: result,
        parentId: 0,
        部门: result,
        公司: this.parentDepartment.公司,
        isDepartment: true,
        组别: null,
        inCompanyParentId:
          this.parentDepartment.pid === this.parentDepartment.公司 ? 'default' : this.parentDepartment._id,
      }
      const res = await app.service('company').insertDepartment(newDepartment)
      if (res.status === 'success') this.loadData()
    },
    showMemberList(nodeData) {
      const option = { company: nodeData.公司 }
      if (nodeData.pid !== nodeData.公司) option.department = nodeData.部门
      app.root.$refs.companyTwoThird.open(option)
    },
    setMemberCharacter(nodeData) {
      this.$refs.OchartCharacter.open(nodeData)
    },
    mergeDepartment(nodeData) {
      this.openDialog('合并部门', nodeData)
      this.mergeMainDepartmentId = nodeData._id
    },
    async confirmMergeDepartment(second) {
      const res = await app
        .service('company')
        .mergeDepartment({ first: this.mergeMainDepartmentId, second: [second._id] })
      if (res.status == 'success') {
        this.$message('合并成功')
        this.loadData()
      }
      this.mergeMainDepartmentId = null
    },
    drag(event, nodeData, nodeType) {
      event.preventDefault()
      event.stopPropagation()
      nodeData.type = nodeType
      this.ochartDragingItem.childItem = nodeData
      this.targetRadishDom = event.target
      this.targetRadishDomDefaultColor = event.target.style.color
      event.target.style.color = '#f56005'
      this.isDraging = true
      this.documentMouseUp()
    },
    drop(event, data, nodeData) {
      if (this.isDraging) {
        event.preventDefault()
        event.stopPropagation()
        this.isDraging = false
        this.targetRadishDom.style.color = this.targetRadishDomDefaultColor
      }
    },
    documentMouseUp() {
      const documentMouseUp = event => {
        if (this.targetRadishDom) this.targetRadishDom.style.color = this.targetRadishDomDefaultColor
        document.removeEventListener('mouseup', documentMouseUp)
        this.isDraging = false
      }
      document.addEventListener('mouseup', documentMouseUp)
    },
    toFilterText(val) {
      this.$refs.tree.filter(val)
    },
    async open(obj) {
      this.activeTabName = '公司架构'
      this.companyName = obj.companyName
      this.companyId = obj.companyId
      this.getCompanyFiles()
      this.isShow = true
      this.showSearch = true
      this.tree = []
      if (this.company && this.company.branch) this.getBrachCompany()
      this.loadData()
    },
    close() {
      this.isShow = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.名称.indexOf(value) !== -1
    },
    managerFilterNode(value, data) {
      if (!value) return true
      return data.姓名.indexOf(value) !== -1
    },
    initChartData() {
      this.chartData = {
        _id: 1,
        名称: '无',
        children: [],
      }
    },
    resetPosition(nodeData) {
      const box = this.$el.querySelector('.departmentOchart-chart')
      if (!box) return
      const boxRect = box.getBoundingClientRect()
      const dom = box.querySelector(`#${nodeData._id}`)
      if (!dom) return
      const domRect = dom.getBoundingClientRect()
      const left = domRect.left - boxRect.left
      box.style.transform = `matrix(1, 0, 0, 1, -${left}, 0)`
    },
    async loadData() {
      this.isLoading = true
      await Promise.all([this.getDepartments(), this.getDepartmentNode(), this.getManagerNode()])
      this.toTreeData(this.managerNode.concat(this.ochartDataItems))
      this.toElementTreeData(this.departmentNodes)
      await this.getCompanyManager()
      this.isLoading = false
    },
    async getCompanyManager() {
      const res = await app.service('company').getCompanyManager({ 公司: this.companyName })
      if (res.status === 'success') {
        this.companyManager = res.data
        this.toManagerTreeData()
      }
    },
    async getDepartmentNode() {
      const res = await app.service('company').getCompanyStructure({ 公司: this.companyName })
      if (res.status === 'success') this.ochartDataItems = res.data
    },
    async getManagerNode() {
      const res = await app.service('company').getCompanyManagerNode({ 公司: this.companyName })
      if (res.status === 'success') this.managerNode = res.data
    },
    async getDepartments() {
      const res = await app.service('company').getCompanyOchart({ 公司: this.companyName })
      if (res.status === 'success') this.departmentNodes = res.data
      else this.$message.error(res.msg)
    },
    initDepartment(department) {
      if (department.inited) return department
      department.pid = department.inCompanyParentId
      department.inited = true
      return department
    },
    toManagerTreeData() {
      const { inStructure } = this
      this.managerTree = this.companyManager.map(node => {
        if (inStructure.manager.find(v => v === node._id)) node.hasSetStructure = true
        return node
      })
    },
    toTreeData(originalArr) {
      const arr = JSON.parse(JSON.stringify(originalArr))
      const tree = []
      const pos = {}
      let i = 0
      let num = 0
      const { companyName } = this
      const inStructure = { department: [], manager: [] }
      const val = arr.map(this.initDepartment)
      while (num < 10000 && val.length !== 0) {
        num++
        const department = val[i]
        if (tree.length === 0 && department.pid === companyName) {
          // 避免显示一条线，但却没有部门
          if (val.length > 1) department.children = []
          tree.push(department)
          pos[department._id] = [0]
          val.splice(i, 1)
          i = -1
        } else if (tree.length !== 0 && department.pid == 'default') {
          if (this.showDepartmentMember && !department.isManager) department.children = [this.getMemberBox(department)]
          tree[0].children.push(department)
          pos[department._id] = [0, tree[0].children.length - 1]
          val.splice(i, 1)
          i = -1
          department.isManager ? inStructure.manager.push(department.rid) : inStructure.department.push(department._id)
        } else if (tree.length !== 0 && department.pid != 'default') {
          const posArr = pos[department.pid]
          if (posArr) {
            let obj = tree[posArr[0]]
            if (!obj.children) obj.children = []
            for (let ind = 1; ind < posArr.length; ind++) {
              obj = obj.children[posArr[ind]]
              if (!obj.children) obj.children = []
            }
            if (this.showDepartmentMember && !department.isManager)
              department.children = [this.getMemberBox(department)]
            obj.children.push(department)
            pos[department._id] = posArr.concat([obj.children.length - 1])
            val.splice(i, 1)
            i = -1
            department.isManager
              ? inStructure.manager.push(department.rid)
              : inStructure.department.push(department._id)
          }
        }
        i++
        if (i > val.length - 1) i = 0
      }
      // 放入分支机构
      if (tree[0] && this.branchCompany && this.branchCompany.length > 0) {
        if (!tree[0].children) tree[0].children = []
        tree[0].children.push(this.getBranchNode())
      }

      this.initOchartPosition()

      this.chartData = tree[0] || {}
      this.inStructure = inStructure
      this.addDrop()
      this.copyChartData = JSON.parse(JSON.stringify(this.chartData))
    },
    getMemberBox(department) {
      const { members = [] } = department
      members.forEach(radish => {
        radish.sort = 专业职级排序[radish.专业职级] || 100
      })
      const maxsort = 专业职级排序[showLevelMin]
      const showMembers = members.filter(val => val.sort <= maxsort)
      showMembers.sort((a, b) => a.sort - b.sort)
      const box = {
        类型: 'members',
        pid: department._id,
        公司: department.公司,
        部门: department.部门,
        members: showMembers,
        _id: `${department._id}-memberbox`,
      }
      return box
    },
    getBranchNode() {
      const obj = {
        类型: 'branch',
        pid: this.companyName,
        members: this.branchCompany,
        _id: `分支机构`,
      }
      return obj
    },
    toElementTreeData(arr) {
      const tree = []
      const { companyName, ochartDataItems, inStructure } = this
      const companyNode = arr.find(v => v.inCompanyParentId === companyName)
      const departments = arr.filter(v => v.inCompanyParentId !== companyName && v.名称 !== '空' && v.名称 !== '高管')
      departments.forEach(department => {
        if (inStructure.department.find(v => v === department._id)) {
          department.hasSetStructure = true
        }
      })
      companyNode.children = departments
      this.tree = [companyNode]
      this.defaultExpandedKeys = [companyNode._id]
    },
    addDrop() {
      this.$nextTick(() => {
        const arr = this.managerNode.concat(this.ochartDataItems)
        arr.map(item => {
          const dom = this.$el.querySelector(`#${item._id}`)
          if (!dom) return
          const str = dom.getAttribute('data-source')
          const data = JSON.parse(str)
          dom.onmouseup = null
          dom.onmouseup = e => {
            e.stopPropagation()
            this.setStructure(data)
          }
        })
      })
    },
    initOchartPosition() {
      this.$nextTick(_ => {
        const dom = this.$el.querySelector('.departmentOchart-chart')
        if (dom) dom.style.transform = 'matrix(1, 0, 0, 1, 0, 0)'
      })
    },
    getDragingItems({ targetId, sourceId, destinationId }) {
      this.ochartDragingItem = { childItem: null, oldParentItem: null, newParentItem: null }
      this.managerNode.concat(this.ochartDataItems).forEach(val => {
        // 被拖拽部门
        if (val._id === targetId) this.ochartDragingItem.childItem = val
        // 被拖拽部门的原父元素
        if (val._id === sourceId) this.ochartDragingItem.oldParentItem = val
        // 被拖拽部门的新父元素
        if (val._id === destinationId) this.ochartDragingItem.newParentItem = val
      })
    },
    async updateDataOnDrag(params) {
      // {targetId: "_id", sourceId: "oldparentId", destinationId: "newparentId"}
      this.getDragingItems(params)

      const { childItem, newParentItem } = this.ochartDragingItem
      this.restoreOchartData()
      const flag = childItem && newParentItem
      if (!flag) return
      if (childItem.isManager || newParentItem.isManager) this.openDialog('移动高管', [childItem, newParentItem])
      else this.openDialog('部2部', [childItem, newParentItem])
    },
    restoreOchartData() {
      this.chartData = JSON.parse(JSON.stringify(this.copyChartData))
    },
    async setStructure(department) {
      const child = this.ochartDragingItem.childItem
      if (!child) return
      if (!this.isDraging) return
      this.ochartDragingItem.newParentItem = department
      this.isDraging = false
      if (child.isManager || child.职级 === '1') this.confirmSetManager()
      else if (department.isManager) {
        await app.service('company').setCompanyStructure({
          departmentId: child._id,
          parentDepartmentId: department._id,
        })
        this.loadData()
      } else this.openDialog('部2部', [child, department])
    },
    openDialog(type, params) {
      this.$refs.OchartDialog.open(type, params)
    },
    cancelDialog(dialogType) {
      if (dialogType === '部2部') this.restoreOchartData()
      else if (dialogType === '改名') this.updateNameDepa = ''
    },
    confirmDialog({ result, dialogType, departmentPosition }) {
      if (dialogType === '部2部') this.confirmDragDepartment(result)
      else if (dialogType === '改名') this.confirmUpdateDepa(result)
      else if (dialogType === '合并部门') this.confirmMergeDepartment(result)
      // else if (dialogType === '高管') this.confirmSetManager(result)
      else if (dialogType === '移动高管') this.confirmDragDepartment(result)
      else this.confirmCreateDepa(result)
    },
    async confirmSetManager() {
      const { childItem, newParentItem } = this.ochartDragingItem
      // if (result === '平级') {
      //   if (newParentItem.公司 === newParentItem.名称) return this.$message.error('高管不能与公司同级')
      //   await app.service('company').setCompanyManager({
      //     radish: childItem,
      //     parentId: newParentItem.pid,
      //   })
      // } else if (result === '下级') {
      const parentDepartmentId = newParentItem.公司 === newParentItem.名称 ? 'default' : newParentItem._id
      await app.service('company').setCompanyManager({
        radish: childItem,
        parentId: parentDepartmentId,
      })
      // }
      this.loadData()
    },
    async confirmDragDepartment(result) {
      const { childItem, newParentItem } = this.ochartDragingItem
      if (childItem._id === newParentItem._id) return this.$message.error('所选的两个部门为同一部门，请重新选择')

      if (result === '平级') {
        if (newParentItem.公司 === newParentItem.名称) return this.$message.error('部门不能与公司同级')
        await app.service('company').setCompanyStructure({
          departmentId: childItem._id,
          parentDepartmentId: newParentItem.pid,
        })
      } else if (result === '下级') {
        const parentDepartmentId = newParentItem.公司 === newParentItem.名称 ? 'default' : newParentItem._id
        await app.service('company').setCompanyStructure({
          departmentId: childItem._id,
          parentDepartmentId: parentDepartmentId,
        })
      } else if (childItem._id === result) {
        await app.service('company').mergeDepartment({ first: childItem._id, second: [newParentItem._id] })
      } else if (newParentItem._id === result) {
        await app.service('company').mergeDepartment({ first: newParentItem._id, second: [childItem._id] })
      }
      this.loadData()
    },
    _showRadishDetail(val) {
      window.open(`${window.frontend}/#/radish-detail-blank/${val.rid || val._id}`, '_blank')
    },
    _showscore(val, type) {
      app.root.$refs.radishScore.open(val.rid || val._id, type, val.名称 || val.姓名)
    },
    openCompany(company) {
      window.open(`${window.origin}#/company/${company._id}`)
    },
    async insertKPI() {
      const result = await app
        .service('company')
        .insertOchartKpi({ user: app.user.account, data: this.chartData, type: '公司' })
      if (result.status === 200) {
        this.$message('保存成功')
      }
    },
  },
}
</script>
<style>
#company-ochart .departmentOchart-chart {
  background-color: #f3f2f2;
  padding-right: 300px;
  padding-bottom: 200px;
}
</style>
<style src="../../statistics/css/companyOchart.css" scoped></style>
<style src="../../statistics/css/departmentOchart.css" scoped></style>
